/*
 * File: 目标管理-目标类型
 */
<template>
    <div class="type-report">
        <Paper class="type-report-paper">
            <list-layout-paper>
                <template slot="header-search">
                    <search-box
                        ref="searchBox"
                        :search-key="config.name"
                        :fields="config.searchFields"
                        @search-change="typeReportList.searchList"
                    />
                </template>
                <template slot="header-button">
                    <lotsButton
                        v-has="authorityCode.add"
                        type="primary"
                        size="mini"
                        title="新增"
                        icon="el-icon-plus"
                        @click="handleAdd"
                    >新增</lotsButton>
                    <lotsButton
                        v-has="authorityCode.export"
                        type="primary"
                        size="mini"
                        title="导出"
                        icon="el-icon-download"
                        @click="handleExport"
                    >导出</lotsButton>
                    <el-tooltip effect="dark" content="列配置" placement="bottom">
                        <el-button icon="iconfont icon-list_install" type="primary" size="mini" @click="handleColumnConfig" plain />
                    </el-tooltip>
                </template>
                <!-- 表格 -->
                <template v-slot:list="{ tableHeight }">
                    <edit-table-box
                        ref="editTableBox"
                        v-loading="typeReportList.tableLoading"
                        :key="rendertable"
                        :index="config.index"
                        :selection="config.selection"
                        :columns="config.columns"
                        :height="tableHeight"
                        :tableData="typeReportList.totalData"
                        :actions="config.actions || []"
                        :rowEdit="config.rowEdit"
                        :allowRowClick="!config.getAuthRole()"
                        :allowRowClickFunc="(row) => config.rowEnableEditFun(row)"
                        :editDisableRule="(row) => !config.rowEnableEditFun(row)"
                        @btn-event="handleActive"
                    >
                        <template #col-append="{item, row}">
                            <!-- 状态 -->
                            <span v-if="item.prop === 'goalTypeStatus'">{{ formatDictCodeToName(row[item.prop], dictDatas[item.optionsKey]) }}</span>
                        </template>
                        <template #edit-col-append="{ item, row }">
                            <!-- 状态 -->
                            <el-select v-if="item.prop === 'goalTypeStatus'" v-model="row[item.prop]" @change="(val) => rendertable++">
                                <el-option
                                    v-for="it in handleDictionaryDataString(dictDatas[item.optionsKey])"
                                    :key="it.value"
                                    :label="it.label"
                                    :value="it.value"
                                />
                            </el-select>
                        </template>
                    </edit-table-box>
                    <!-- 表格列配置弹框 -->
                    <column-config
                        ref="columnConfigRef"
                        :pageID="config.name"
                        :initColumns="config.columns"
                        @header-change="config.columns = $event"
                    />
                </template>
                <template slot="footer">
                    <lots-pagination
                        @size-change="typeReportList.sizeChange"
                        :current-page.sync="typeReportList.pageNo"
                        @current-change="typeReportList.pageChange"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="typeReportList.pageTotal"
                    />
                </template>
            </list-layout-paper>
        </Paper>
    </div>
</template>

<script>
import { ref, reactive, onMounted, onActivated } from '@vue/composition-api';
import { Message } from 'element-ui';
import btnAuthority from '@/modules/mdm/btnAuthority.js';
import otherUtils from '@/modules/mdm/utils/otherCommonFunc.js';
import { formatDictCodeToName, handleDictionaryDataString } from '@/modules/mdm/utils.js';
import _ from 'lodash';
import { AdvanceListClass } from '@/modules/mdm/composition/dc/common/list/AdvanceListClass';
import Paper from '@/components/core/Paper';
import listLayoutPaper from '@/components/lots/listLayout/Paper';
import searchBox from '@/components/lots/searchBox';
import lotsButton from '@/components/lots/lotsButton';
import editTableBox from '@/components/lots/editTableBox/Index';
import lotsPagination from '@/components/lots/lotsPagination/Index';
import columnConfig from '@/components/lots/columnConfig/Index';
import { getDictDataApi } from '@mdm/api/contractManage/contractListApi.js';
import { getTypeReportList, saveTypeReportList, exportTypeReportList } from '@mdm/api/targetModdeules/typeReport.js';
import { config as configStatic } from './config';

export default {
    name: 'typeReport',
    components: {
        Paper,
        listLayoutPaper,
        searchBox,
        lotsButton,
        editTableBox,
        lotsPagination,
        columnConfig
    },
    /* eslint-disable max-lines-per-function */
    setup(props, setupContext) {
        const authorityCode = reactive(btnAuthority.typeReport);
        const config = reactive(configStatic);
        const dictDatas = ref({});
        const rendertable = ref(1);

        class AccountListClass extends AdvanceListClass {
            beforeGetList(condition) {
                return searchDataFormat(condition);
            };
            afterGetList (res) {
                if (+res.code === 0) {
                    this.totalData.value = res.data.list.map((v) => ({
                        edit: -3,
                        allowEdit: true,
                        ...v,
                        goalTypeStatus: v.goalTypeStatus?.toString()
                    }));
                    this.pageTotal.value = res.data.totalCount;
                }
                setupContext.root.$nextTick(() => {
                    setupContext.refs.editTableBox.$refs.moduleTable.doLayout(); // 解决表格错位
                });
            };
        }
        const typeReportList = new AccountListClass({
            Api: {
                listApi: getTypeReportList // 查询接口
            }
        });
        // 查询参数转换
        const searchDataFormat = (condition = {}, params = {}) => {
            const newParams = { ...condition, ...params };
            Object.keys(newParams).forEach(v => {
                if (newParams[v] === undefined || newParams[v] === null || newParams[v] === '') {
                    delete newParams[v];
                }
            });
            return newParams;
        };
        // 新增
        const handleAdd = () => {
            typeReportList.totalData.value.unshift({
                edit: 2,
                allowEdit: true,
                goalTypeStatus: '1' // 启用
            });
            const timer = setTimeout(() => { // 解决表格错位
                setupContext.refs.editTableBox.$refs.moduleTable.doLayout();
            });
            timer && clearTimeout(timer);
        };
        // 导出
        const handleExport = async (submit) => {
            await setupContext.refs.searchBox.submitSearch(); // 解决输入参数不生效问题
            const { value } = typeReportList.searchModel;
            const newData = _.cloneDeep(value); // 解决搜索参数被清空的问题
            const excelTitleList = otherUtils.sortColumnsByFixed(config.columns)?.map((item) => ({
                name: item.name,
                property: item.property
            }));
            const params = {
                ...searchDataFormat(newData),
                deleteFlag: 0,
                excelTitleList
            };
            exportTypeReportList(params).then(res => {
                if (+res.code === 0) {
                    Message.success('已发送导出请求,请稍后到右上角用户文件列表中下载');
                }
            });
        };
        // 列配置
        const handleColumnConfig = () => {
            setupContext.refs.columnConfigRef.show(true);
        };
        // 操作项
        const handleActive = (row, event) => {
            // 取消
            if (event === 'cancel') {
                rendertable.value++;
            }
            // 保存
            if (event === 'save') {
                handleSave(row);
            }
        };
        // 保存
        const handleSave = (row) => {
            const params = { ...row, goalTypeName: _.trim(row.goalTypeName) };
            saveTypeReportList(params).then(res => {
                if (+res.code === 0) {
                    Message.success('保存成功');
                    typeReportList.getList();
                }
            }).finally(() => {});
        };

        onActivated(() => {
            setupContext.refs.editTableBox.$refs.moduleTable.doLayout(); // 解决表格错位
        });
        onMounted(async () => {
            setupContext.refs.searchBox.submitSearch();
            const { data } = await getDictDataApi({ dictCodes: 'CRM_GOAL_STATUS' });
            dictDatas.value = data || {};
        });

        return {
            config,
            authorityCode,
            typeReportList,
            dictDatas,
            rendertable,
            formatDictCodeToName,
            handleDictionaryDataString,
            handleAdd,
            handleExport,
            handleColumnConfig,
            handleActive
        };
    }
};
</script>

<style lang="less">
.type-report {
    width: 100%;
    .type-report-paper {
        height: 100%;
    }
    .header-button {
        margin-left: 10px;
    }
    .search-box .el-select .el-input input {
        height: 28px!important;
    }
    .list-layout-wrapper {
        height: 100%;
    }

    .list-layout .list-header .el-input {
        margin-left: 0;
    }
    .flex-layout .list-main {
        overflow: auto;
    }

    .flex-layout .table {
        overflow-y: auto;
    }

    .layout-content.type-report-paper {
        padding: 0px 0px 0px;
    }
    .edit-table-box .el-select {
        width: 100%;
    }
}
</style>
